/** 平台官网(设计图 01–04)的公开只读接口:/v1/site/* */
import type { ApiClient } from './client.js';
import type { Organizer, PublicityRow } from './contest.js';

export interface SiteOverview {
  productLines: number;
  courses: number;
  levels: number;
  contests: number;
  signupOpen: { site: string; name: string; signupEnd: string | null }[];
}
export interface CourseCard {
  id: string;
  name: string;
  track: string;
  trackLabel: string;
  intro: string | null;
  productLineId: string | null;
  levels: number;
  freeLevels: number;
  chapters: number;
  lessonHoursPerLevel: number;
  passThreshold: number;
}
export interface CatalogLine {
  id: string;
  code: string;
  name: string;
  tagline: string | null;
  intro: string | null;
  audience: string | null;
  freeParts: number;
  courses: CourseCard[];
  parts: {
    seq: number;
    name: string;
    knowledge: string;
    goal: string;
    assessmentKind: string;
    levelFrom: number | null;
    levelTo: number | null;
  }[];
}
export interface SiteCatalog {
  lines: CatalogLine[];
  courses: CourseCard[];
}
export interface SiteContest {
  site: string;
  name: string;
  intro: string | null;
  signupStart: string | null;
  signupEnd: string | null;
  state: 'soon' | 'signup' | 'running' | 'ended' | 'archived';
  organizers: Organizer[];
}
export interface SiteNotice {
  id: string;
  site: string;
  contestName: string;
  title: string;
  summary: string | null;
  kind: string;
  tag: string;
  publishedAt: string | null;
}
export interface BoardOptions {
  levels: { id: string; courseId: string; courseName: string; seq: number; name: string }[];
  exams: { id: string; name: string; subject: string; groups: string[]; publishedAt: string | null }[];
  contests: { id: string; title: string; contestName: string; publishedAt: string | null }[];
}
export interface BoardRow {
  rank: number;
  nickname: string;
  score: number;
  grade: string | null;
  durationSec: number | null;
  me?: boolean;
}
export interface ExamBoard {
  exam: { id: string; name: string };
  group: string | null;
  groups: { key: string; label: string }[];
  entries: BoardRow[];
}
export interface ContestBoard {
  title: string;
  contestName: string;
  site: string;
  entries: (PublicityRow & { awardLevel: string | null })[];
}

export function siteApi(api: ApiClient) {
  const S = '/v1/site';
  return {
    overview: () => api.get<SiteOverview>(`${S}/overview`),
    catalog: () => api.get<SiteCatalog>(`${S}/catalog`),
    contests: () => api.get<SiteContest[]>(`${S}/contests`),
    notices: () => api.get<SiteNotice[]>(`${S}/notices`),
    boardOptions: () => api.get<BoardOptions>(`${S}/boards`),
    levelBoard: (levelId: string, period: string) =>
      api.get<{ total: number; entries: BoardRow[] }>(`${S}/boards/level/${levelId}`, { query: { period } }),
    examBoard: (examId: string, group?: string) =>
      api.get<ExamBoard>(`${S}/boards/exam/${examId}`, { query: { group } }),
    contestBoard: (noticeId: string) => api.get<ContestBoard>(`${S}/boards/contest/${noticeId}`),
  };
}
export type SiteApi = ReturnType<typeof siteApi>;
